import { render, staticRenderFns } from "./BracBranchAccountList.vue?vue&type=template&id=10567b70&"
import script from "./BracBranchAccountList.vue?vue&type=script&lang=js&"
export * from "./BracBranchAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports